import React, { useEffect, useState } from 'react'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Meals from './Meals';
import ScrollableFeed from 'react-scrollable-feed'
import Menuinfo from './Menuinfo';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Reviews from './Reviews';
import Rating from '@mui/material/Rating';
import { auth, db } from '../../../../firebase';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
function Post({ mealImage, branchId, mealArrayIds, menuName, menuCategories, rating, restId,menuAvailability, menuId, numberOfRating , posts, createdById, restaurant }) {
    const [lgShow, setLgShow] = useState(false);
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const [see,setSee] = useState()
    const [posts2, setPosts2] = useState([])

    useEffect(() => {
      db.collection('reviews').where("menuId","==",menuId).onSnapshot(snapshot => {
          setPosts2(snapshot.docs.map(doc => ({
              id: doc.id,
              post: doc.data(),
          })));
      })
  }, []);

 const totalRatings = (posts2.reduce((a,v) =>  a = a + v.post.rating , 0 ))
 const numberOfRatings = posts2.length
 const rating2 = totalRatings / numberOfRatings
 var a = Math.round(rating2 * 10) / 10
 var b = posts2.length
    
    const likePost = () =>{
      // Alert.alert("Be Aware", "You liked the post!") 
      db.collection("users").doc(auth?.currentUser?.uid).collection("Favourites").where("fromId", "==", auth?.currentUser?.uid).where("menuId", "==",menuId ).get().then(
          snap => {
            if (snap.docs.length > 0) {
              db.collection("users").doc(auth?.currentUser?.uid).collection("Favourites").doc(menuId).delete().then(function() {
              }).catch(function(error) {
                  alert("Error removing post: ", error);
              });                
          
            } else {
              db.collection("users").doc(auth?.currentUser?.uid).collection("Favourites").doc(menuId).set({
                    fromId: auth?.currentUser?.uid,
                    menuId,
                    type:'menu',
                    branchId,
                    restId,
                    timestamp:Date.now(),  
                    liked:true,  
                    mealImage, 
                    mealArrayIds, 
                    menuName, 
                    menuCategories,
                    rating,
                    menuAvailability,
                    createdById,
                    restaurant    
                })
            }
          }
        )
  }
          

  useEffect(() => {
    db.collection('users').doc(`${auth?.currentUser?.uid}`).collection("Favourites").doc(menuId).onSnapshot((doc) => {
        setSee(doc.data());
    });
}, [])
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    const handleChangeIndex = (index) => {
      setValue(index);
    };
  return (
      <>
      {posts !== '' ?(
          <>
  <div className=" col-md-4 col-sm-6 mb-4">
               {/* <div className="col-md-4 col-sm-6 mb-4"> */}
                      <div style={{marginLeft:5,border:'1px solid #88888888',padding:1,borderRadius:10}} className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
          <div className="list-card-image">
            <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" />{numberOfRatings === 0 ?(<>0</>):(<>{a}</>)} </span></div>
            <div className="favourite-heart text-danger position-absolute"><a >
            {auth?.currentUser?.uid ?(
                      <a className="woo_cart_btn btn_save">
                        {see?.liked === true ?(
                        <FavoriteIcon onClick={likePost} style={{color: '#e74c3c',backgroundColor:'#fff',borderRadius:10}}/>
                        ):(
                          <FavoriteBorderOutlinedIcon onClick={likePost} className="ti-heart" style={{color:'#e74c3c',backgroundColor:'#fff',borderRadius:10}}/>
                        )}
                        </a>
                      ):(
                        <li><a onClick={() => alert("Kindly sign In first.\nThanks!")} className="woo_cart_btn btn_save"><FavoriteBorderOutlinedIcon style={{color:'#e74c3c',backgroundColor:'#fff',borderRadius:10}} className="ti-heart" /></a></li>
                      )}
              </a></div>
            <a href="#">
              <img src={mealImage} style={{height:130,width:'100%',objectFit:'cover'}}  className="img-fluid item-img" />
            </a>
          </div>
          <div className="p-3 position-relative">
            <div className="list-card-body">
              <h6 className="mb-1"><a  className="text-black">{menuName}</a></h6>
              <p className="text-gray mb-2">Meals ({mealArrayIds.length})</p>
              <p className="text-gray time mb-0">
                <Rating style={{cursor:'pointer'}} name="half-rating-read" value={a} precision={0.5} readOnly />
                 <span className="float-right">
                 <a href="javascript:void(0);" onClick={() => setLgShow(true)} className="woo_cart_btn btn_cart"><VisibilityOutlinedIcon style={{color:'#e74c3c'}} className="ti-eye"/></a>
                </span>
              </p>
            </div>
          </div>
        </div> 
        </div> 
          </>
      ):(
          <>
          <h1>No Menus!</h1>
          </>
      )}

      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{height:'99%'}}
      >
        <Modal.Header closeButton style={{position: 'sticky',top:0, zIndex:4, height:50}}>
          <Modal.Title id="example-modal-sizes-title-lg">

           {/* <center>Menu Details</center>  */}
           <ClearOutlinedIcon style={{cursor:'pointer'}} onClick={() => setLgShow(false)}/>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <AppBar style={{position: 'sticky',top:0, zIndex:4,width:'100%'}}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          backgroundColor='#ff5722'
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          style={{backgroundColor: '#f5461b'}}
        >
          <Tab label={`MEALS (${mealArrayIds.length})`} {...a11yProps(0)} />
          <Tab label="MENU INFO" {...a11yProps(1)} />
          <Tab label={`RATES & REVIEWS (${b})`} {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
     <ScrollableFeed>
     <div style={{marginTop:-35}} className="all-product-grid">
        <div className="container">
          <div className="product-list-view">
            <div style={{display:'flex',flexWrap:'wrap'}} className="row">
            {mealArrayIds.map(mealId => (  
            <Meals mealId={mealId} branchId={branchId} restId={restId} menuId={menuId}/>
        ))}  
          </div>
          </div>
        </div>
      </div>
     </ScrollableFeed>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
        <ScrollableFeed>
          <Menuinfo menuName={menuName} menuCategories={menuCategories} rating={rating} menuAvailability={menuAvailability} menuId={menuId} branchId={branchId} restId={restId} createdById={createdById} mealImage={mealImage}/>
        </ScrollableFeed>
        </TabPanel>

        <TabPanel value={value} index={2} dir={theme.direction}>
        <ScrollableFeed>
          <Reviews menuId={menuId} branchId={branchId} restId={restId}/>
        </ScrollableFeed>
        </TabPanel>
      </SwipeableViews>
    </Box>
        </Modal.Body>

      </Modal>
    {/* End Modal */}

              </>
         
  )
}

export default Post
